module.exports = __webpack_public_path__ + "static/media/bali-bombings-feature-banner-lg@1x.b11c57b1.webp";